<div>
  <button class="d-flex align-items-center" [ngClass]="{'button-collapsed': collapsed}"
          (click)="collapsedChange.emit(!collapsed)">
    <i class="material-icons mr-2">tune</i>
    <span>{{name}}</span>
    <i class="material-icons ml-2" *ngIf="!collapsed">expand_less</i>
    <i class="material-icons ml-2" *ngIf="collapsed">expand_more</i>
  </button>
</div>
